import { useLocation, useNavigate } from 'react-router-dom';
import { RoutePaths, routes } from '../../config/routes';
export var useWizard = function () {
    var _a;
    var navigate = useNavigate();
    var pathname = useLocation().pathname;
    var wizardKey = '_wizard';
    var signUpRoutes = routes.find(function (route) { return route.path === RoutePaths.SIGN_UP_PROFESSIONAL; });
    var wizardSteps = (_a = signUpRoutes === null || signUpRoutes === void 0 ? void 0 : signUpRoutes.children) === null || _a === void 0 ? void 0 : _a.map(function (route) {
        return route.index ? RoutePaths.SIGN_UP_PROFESSIONAL : route.path;
    });
    var getStep = function (path) {
        if (!path)
            return { index: 0, path: RoutePaths.SIGN_UP_PROFESSIONAL };
        var index = wizardSteps.indexOf(path);
        return { index: index, path: wizardSteps[index] };
    };
    var getNextStep = function () {
        var index = wizardSteps.indexOf(pathname);
        if (index === wizardSteps.length - 1)
            return { index: wizardSteps.length + 1, path: RoutePaths.SIGN_IN_SITUATION };
        return getStep(wizardSteps[index + 1]);
    };
    var getPreviousStep = function () {
        var index = wizardSteps.indexOf(pathname);
        if (index === 0)
            return { index: -1, path: RoutePaths.SIGN_IN_SITUATION };
        return getStep(wizardSteps[index - 1]);
    };
    var setWizard = function (values) {
        var wizard = { values: values, lastStep: getStep(pathname) };
        localStorage.setItem(wizardKey, JSON.stringify(wizard));
    };
    var getWizard = function () {
        var localStorageValues = localStorage.getItem(wizardKey);
        if (localStorageValues)
            return JSON.parse(localStorageValues);
        return null;
    };
    var setValuesAndGoToNextStep = function (values) {
        setWizard(values);
        var nextStep = getNextStep();
        if (nextStep)
            return navigate(getStep(nextStep.path).path);
    };
    var skipAndGoToNextStep = function () {
        var _a;
        var values = (_a = getWizard()) === null || _a === void 0 ? void 0 : _a.values;
        var wizard = { values: values, lastStep: getStep(pathname) };
        localStorage.setItem(wizardKey, JSON.stringify(wizard));
        var nextStep = getNextStep();
        if (nextStep)
            return navigate(getStep(nextStep.path).path);
    };
    var clearWizard = function () {
        localStorage.removeItem(wizardKey);
    };
    return {
        wizardSteps: wizardSteps,
        getWizard: getWizard,
        setWizard: setWizard,
        setValuesAndGoToNextStep: setValuesAndGoToNextStep,
        skipAndGoToNextStep: skipAndGoToNextStep,
        clearWizard: clearWizard,
        getStep: getStep,
        getNextStep: getNextStep,
        getPreviousStep: getPreviousStep,
    };
};
